import type { TravelerInfo } from "@/api/car";

import { maskMiddle } from "../utils";

type Props = {
  renter: TravelerInfo;
};

export default function CarRenterSection({ renter }: Props) {
  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl p-4">
      <div className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
        <i
          className="ri-user-line"
          style={{ color: "#FF6B35", fontSize: 15 }}
        />
        租车人信息
      </div>
      <div className="grid grid-cols-2 gap-2">
        {[
          {
            label: "租车人",
            value: renter.name || "—",
            icon: "ri-user-line",
          },
          {
            label: "联系电话",
            value: renter.phone?.trim() || "—",
            icon: "ri-phone-line",
          },
          {
            label: "驾照号",
            value: renter.license_number
              ? maskMiddle(renter.license_number, 2)
              : "—",
            icon: "ri-car-line",
          },
          {
            label: "驾照类型",
            value:
              [renter.license_type, renter.license_expire_date]
                .filter(Boolean)
                .join(" · ") || "—",
            icon: "ri-road-map-line",
          },
        ].map((item) => (
          <div
            key={item.label}
            className="rounded-xl p-2.5"
            style={{ background: "#F8F8F8" }}
          >
            <div className="flex items-center gap-1 mb-0.5">
              <i
                className={item.icon}
                style={{ color: "#9CA3AF", fontSize: 11 }}
              />
              <span className="text-xs text-gray-400">{item.label}</span>
            </div>
            <span className="text-xs font-semibold text-gray-800">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
